import { useContext } from 'react';
import { TrainingJournalContext } from './journal-context';

export const useTrainingJournal = () => {
  const context = useContext(TrainingJournalContext);
  if (!context) {
    throw new Error('useTrainingJournal must be used within a TrainingJournalProvider');
  }
  return context;
};
